module.exports = __webpack_public_path__ + "img/bb-logo-white.e526b0bc.svg";